import { Input, LabelledField } from "@mixitone/components";
import { ApplicationView } from "@mixitone/mvc";
import { AuthController } from "../../../controllers/AuthController";
import { CompetitionRegistrationPageController } from "../controllers/CompetitionRegistrationPageController";

const EmailValidationForm = () => {
  const controller = CompetitionRegistrationPageController.use();
  const authController = AuthController.use();
  const { formData } = controller.state;
  const emailIsVerified = authController.emailIsVerified;

  return (
    <>
      <p className="mb-4 text-sm text-gray-600">
        Please enter your name and email address to continue.
        {!emailIsVerified && " We'll send you a verification email with a link to continue registration."}
      </p>

      <LabelledField label="Name" htmlFor="name" required>
        <Input
          type="text"
          id="name"
          value={formData.name}
          onChange={(e) => (controller.state.formData.name = e.target.value)}
          required
          minLength={2}
          showValid
        />
      </LabelledField>

      <LabelledField
        label="Email"
        required
        helpText={!emailIsVerified ? "Your email will be shared with the tournament organizer." : undefined}
        htmlFor="email"
      >
        <Input
          id="email"
          value={formData.email}
          onChange={(e) => !emailIsVerified && (controller.state.formData.email = e.target.value)}
          required
          showValid
          type="email"
          disabled={emailIsVerified}
        />
        {emailIsVerified && <p className="mt-1 text-sm text-green-600">Email verified</p>}
      </LabelledField>
    </>
  );
};

export default ApplicationView(EmailValidationForm);
